import { authUserProps } from "src/interfaces";
import { store } from "src/stores";
import { fetchUserPermissions, logout } from "src/stores/auth";
import {
  isSameBrowserSession,
  isSessionExpired,
  markSessionActive,
} from "./session";

const isNotificationDeepLink = () => {
  try {
    const path = window.location.pathname || "";
    const params = new URLSearchParams(window.location.search);
    const pending = sessionStorage.getItem("pendingNotificationTarget");
    return (
      !!pending ||
      path.includes("/query-detail") ||
      path.includes("/reminders") ||
      params.get("source") === "pwa" ||
      params.has("notification_id")
    );
  } catch {
    return false;
  }
};

export const appInitializer = (authUser: authUserProps) => {
  const isLoggedIn = !!authUser?.token;
  const isPersist = authUser?.isPersist;

  if (!isLoggedIn) {
    return;
  }

  const sameTab = isSameBrowserSession();
  const sessionExpired = isSessionExpired();
  const fromNotification = isNotificationDeepLink();

  // New tabs (including notification clicks) do not inherit sessionStorage.
  // Only end the session when Remember Me is off AND the previous session
  // has been idle long enough to expire.
  if (!sameTab && !isPersist && sessionExpired && !fromNotification) {
    store?.dispatch(logout());
    return;
  }

  markSessionActive();
  store?.dispatch(fetchUserPermissions());
};
